// GET VOLUNTEERS
export const GET_VOLUNTEERS_START = "GET_VOLUNTEERS_START";
export const GET_VOLUNTEERS_SUCCESS = "GET_VOLUNTEERS_SUCCESS";
export const GET_VOLUNTEERS_FAILURE = "GET_VOLUNTEERS_FAILURE";

// DELETE VOLUNTEERS
export const DELETE_VOLUNTEER_START = "DELETE_VOLUNTEER_START";
export const DELETE_VOLUNTEER_SUCCESS = "DELETE_VOLUNTEER_SUCCESS";
export const DELETE_VOLUNTEER_FAILURE = "DELETE_VOLUNTEER_FAILURE";
